import { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";

export default function AdSlot({ slot = "team_bottom", label = "ADVERTISEMENT" }) {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    api.get(`/ads?slot=${slot}`).then(({ data }) => setAd((data.ads || [])[0] || null)).catch(() => {});
  }, [slot]);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 sm:px-8 lg:px-12" data-testid={`ad-slot-${slot}`}>
      <p className="mb-2 text-center font-score text-[10px] tracking-[0.3em] text-slate-600">{label}</p>
      {ad ? (
        <a
          href={ad.link_url || "#"}
          target={ad.link_url?.startsWith("http") ? "_blank" : undefined}
          rel="noreferrer"
          data-testid={`ad-slot-${slot}-link`}
          className="group flex h-28 items-center justify-center overflow-hidden rounded-lg border border-dashed border-bline bg-surface/60 transition-colors hover:border-volt/50"
        >
          {ad.image_url ? (
            <img src={fileUrl(ad.image_url)} alt={ad.advertiser} className="h-full w-full object-cover" />
          ) : (
            <span className="font-display text-2xl tracking-[0.25em] text-slate-600 transition-colors group-hover:text-volt">
              {ad.advertiser?.toUpperCase() || "YOUR BRAND HERE"}
            </span>
          )}
        </a>
      ) : (
        <div className="flex h-28 items-center justify-center rounded-lg border border-dashed border-bline bg-surface/40">
          <span className="font-display text-2xl tracking-[0.25em] text-slate-700">AD SPACE AVAILABLE</span>
        </div>
      )}
    </div>
  );
}
